module.exports = __webpack_public_path__ + "static/tiger-247e162d45a96be4f758b4ba320a0ff0.svg";